/** Strips query string and hash from a router `asPath` value. */
export const getBrowserPathFromAsPath = (asPath: string): string => {
  return asPath.split(/[?#]/, 1)[0] ?? '';
};
